import script from "./DirectComponentItem.vue?vue&type=script&setup=true&lang=js"
export * from "./DirectComponentItem.vue?vue&type=script&setup=true&lang=js"

import "./DirectComponentItem.vue?vue&type=style&index=0&id=7114792d&lang=css"

const __exports__ = script;

export default __exports__